import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.5 0A3.5 3.5 0 0 0 0 3.5v7A3.5 3.5 0 0 0 3.5 14h7a3.5 3.5 0 0 0 3.5-3.5v-7A3.5 3.5 0 0 0 10.5 0zm3.103 4.345a.625.625 0 0 0-1.14-.156L4.146 6.395H2.5a.625.625 0 1 0 0 1.25h2c.22 0 .424-.116.537-.305l.746-1.25 1.114 4.084a.625.625 0 0 0 1.123.183l1.814-2.712H11.5a.625.625 0 1 0 0-1.25h-2a.63.63 0 0 0-.52.277L7.743 8.523z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const interfaceSignalSquare = { render };
export {
  interfaceSignalSquare as default,
  render
};
//# sourceMappingURL=interface-signal-square.svg.js.map
